import {
  Button,
  DatePicker,
  IconDocument,
  IconSearch,
  IconX,
  MomentObj,
  Select,
  SelectOption,
  Table,
  TableColumns,
  TableData,
  Tabs,
  TextBox,
  Toggle,
} from "@veneer/core";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import "../../assets/css/views/metrics/metrics.css";
import moment from "moment";
import { rangeBeforeAndAfterDates } from "../../utils/formatDates/rangeBeforeAndAfterDates";
import metricService from "../../services/surveyApi/metrics.service";
import dataListService from "../../services/generalApi/dataList.service";
import { IFormMetricsIn } from "../../models/input/surveyApi/IFormMetricsIn";
import ITableColumnMapping, {
  fillDataGeneric,
  fillDataMetricByPos,
  fillDataMetricSync,
  fillDataMetricTraining,
  fillDataMetricByAdvisor,
  fillDataMetricCheckIn,
} from "./MetricsComponent/fillDateTable";
import { FormatDate } from "../../utils/conversion";
import LoaderModal from "../../components/Loader/loaderModal";
import { IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";

interface Pagination {
  currentPage: number;
  pageSize: number;
  supervisorName: string;
  promotorName: string;
}
interface PaginationState {
  [key: string]: Pagination;
}

export default function Metrics() {
  const [t] = useTranslation("global");
  const [tableDataMetrics1, setTableDataMetrics1] = useState<TableData[]>([]);
  const [tableDataSync, setTableDataSync] = useState<TableData[]>([]);
  const [tableDataCheckIn, setTableDataCheckIn] = useState<TableData[]>([]);
  const [tableDataTraining, setTableDataTraining] = useState<TableData[]>([]);
  const [tableDataAbsences, setTableDataAbsences] = useState<TableData[]>([]);
  const [tableDataAbsencesCheckIn, setTableDataAbsencesCheckIn] = useState<TableData[]>([]);
  const [tableDataMetrics2, setTableDataMetrics2] = useState<TableData[]>([]);
  const [tableDataSosPrint, setTableDataSosPrint] = useState<TableData[]>([]);
  const [tableDataSosPc, setTableDataSosPc] = useState<TableData[]>([]);
  const [tableDataCompAdvisors, setTableDataCompAdvisors] = useState<
    TableData[]
  >([]);
  const [tableDataExecVisualPrint, setTableDataExecVisualPrint] = useState<
    TableData[]
  >([]);
  const [tableDataExecVisualPc, setTableDataExecVisualPc] = useState<
    TableData[]
  >([]);
  const [tableDataExecVisualPrintStatus, setTableDataExecVisualPrintStatus] =
    useState<TableData[]>([]);
  const [tableDataExecVisualPcStatus, setTableDataExecVisualPcStatus] =
    useState<TableData[]>([]);
  const [selectedTabIdDefault, setSelectedTabIdDefault] = useState(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [valueCoordinator, setValueCoordinator] = useState<number[]>([]);
  const [valueSupervisor, setValueSupervisor] = useState<number[]>([]);
  const [valueAdvisor, setValueAdvisor] = useState<boolean>(false);
  const [valuePointOfSale, setValuePointOfSale] = useState<boolean>(false);
  const [optionsCoordinator, setOptionsCoordinator] = useState<SelectOption[]>(
    []
  );
  const [optionsSupervisor, setOptionsSupervisor] = useState<SelectOption[]>(
    []
  );
  const [startDate, setStartDate] = useState<moment.Moment | undefined>(
    undefined
  );
  const [endDate, setEndDate] = useState<moment.Moment | undefined>(undefined);
  const [disabledEndDate, setDisabledEndDate] = useState<boolean>(true);
  const [disabledSupervisor, setDisabledSupervisor] = useState<boolean>(true);
  const [disabledAdvisor, setDisabledAdvisor] = useState<boolean>(true);
  const [disabledPointOfSale, setDisabledPointOfSale] = useState<boolean>(true);
  const [isButtonValid, setIsButtonValid] = useState<boolean>(true);
  const [isButtonValidDowload, setIsButtonValidDowload] = useState<boolean>(true);
  const [message, setMessage] = useState<string>("");
  const [showTable1, setShowTable1] = useState<boolean>(false);
  const [showTable2, setShowTable2] = useState<boolean>(false);
  const [showTable3, setShowTable3] = useState<boolean>(false);
  const [selectedTable, setSelectedTable] = useState<string>("");
  const languageID: any = useSelector((state: RootState) => state.languageId);

  const initialPaginationState = {
    currentPage: 1,
    pageSize: 10,
    supervisorName: "",
    promotorName: "",
  };

  useEffect(() => {
    if (showTable1) {
      setSelectedTable("DownloadMetricByAdvisor")
    } else if (showTable2) {
      setSelectedTable("DownloadMetricByAdvisor")
    } else if (showTable3) {
      setSelectedTable("DownloadMetricByPos")
    }
  }, [showTable1, showTable2, showTable3]);

  const [paginationState, setPaginationState] = useState<PaginationState>({
    tableDataMetrics1: initialPaginationState,
    tableDataSync: initialPaginationState,
    tableDataCheckIn: initialPaginationState,
    tableDataTraining: initialPaginationState,
    tableDataAbsences: initialPaginationState,
    tableDataMetrics2: initialPaginationState,
    tableDataSosPrint: initialPaginationState,
    tableDataSosPc: initialPaginationState,
    tableDataCompAdvisors: initialPaginationState,
    tableDataExecVisualPrint: initialPaginationState,
    tableDataExecVisualPc: initialPaginationState,
    tableDataExecVisualPrintStatus: initialPaginationState,
    tableDataExecVisualPcStatus: initialPaginationState,
    tableDataAbsencesCheckIn: initialPaginationState,
  });

  const resetPagination = () => {
    setPaginationState((prevState) => {
      const resetState = Object.keys(prevState).reduce((acc, key) => {
        acc[key] = initialPaginationState;
        return acc;
      }, {} as Record<string, typeof initialPaginationState>);
      return resetState;
    });
  };

  useEffect(() => {
    getCoordinatorBySubRegion();
  }, []);

  const initialFormState = {
    page: 0,
    rowCount: 10,
    startDate: "",
    endDate: "",
    coordinatorId: 0,
    supervisorId: 0,
    supervisorName: "",
    promotorName: "",
    sp: "",
    languageID: languageID?.value,
  };

  const [form, setForm] = useState<IFormMetricsIn>(initialFormState);

  const initialValidationState = {
    StartDate: false,
    EndDate: false,
    Coordinator: false,
    Supervisor: false,
    Advisor: false,
    PointOfSale: false,
  };

  const cleanTableData = () => {
    setTableDataMetrics1([]);
    setTableDataSync([]);
    setTableDataCheckIn([]);
    setTableDataTraining([]);
    setTableDataAbsences([]);
    setTableDataAbsencesCheckIn([]);
    setTableDataMetrics2([]);
    setTableDataSosPrint([]);
    setTableDataSosPc([]);
    setTableDataCompAdvisors([]);
    setTableDataExecVisualPrint([]);
    setTableDataExecVisualPc([]);
    setTableDataExecVisualPrintStatus([]);
    setTableDataExecVisualPcStatus([]);
    resetPagination();
    setShowTable1(false);
    setShowTable2(false);
    setShowTable3(false);
    resetPagination();
    setSelectedTabIdDefault(1);
    setSelectedTable("");
    setIsButtonValidDowload(true)
  };

  const clearFilters = () => {
    setValueCoordinator([]);
    setValueSupervisor([]);
    setTableDataMetrics1([]);
    setTableDataSync([]);
    setTableDataCheckIn([]);
    setTableDataTraining([]);
    setTableDataAbsences([]);
    setTableDataAbsencesCheckIn([]);
    setTableDataMetrics2([]);
    setTableDataSosPrint([]);
    setTableDataSosPc([]);
    setTableDataCompAdvisors([]);
    setTableDataExecVisualPrint([]);
    setTableDataExecVisualPc([]);
    setTableDataExecVisualPrintStatus([]);
    setTableDataExecVisualPcStatus([]);
    setValueAdvisor(false);
    setValuePointOfSale(false);
    setEndDate(undefined);
    setStartDate(undefined);
    setDisabledEndDate(true);
    setDisabledSupervisor(true);
    setDisabledAdvisor(true);
    setDisabledPointOfSale(true);
    setIsButtonValid(true);
    setShowTable1(false);
    setShowTable2(false);
    setShowTable3(false);
    setHandleValidate(initialValidationState);
    setForm(initialFormState);
    setSelectedTabIdDefault(1);
    resetPagination();
    setSelectedTable("");
    setIsButtonValidDowload(true)
  };

  const [handleValidate, setHandleValidate] = useState(initialValidationState);

  const memoizedHandleValidate = useMemo(
    () => handleValidate,
    [handleValidate]
  );

  useEffect(() => {
    const {
      StartDate,
      EndDate,
      Coordinator,
      Supervisor,
      Advisor,
      PointOfSale,
    } = memoizedHandleValidate;
    const hasAtLeastOneFalse = Object.values(memoizedHandleValidate).some(
      (value) => value === false
    );

    setIsButtonValid(true);
    if (
      StartDate &&
      EndDate &&
      !Coordinator &&
      !Supervisor &&
      !Advisor &&
      !PointOfSale
    ) {
      return setIsButtonValid(false);
    }

    if (!hasAtLeastOneFalse) {
      return setIsButtonValid(false);
    }
  }, [memoizedHandleValidate]);

  useEffect(() => {
    if (optionsSupervisor.length > 0) {
      const hasZeroValue = optionsSupervisor.some((item) => item.value === 0);
      if (hasZeroValue) {
        setIsButtonValid(true);
        setHandleValidate((prevState) => ({
          ...prevState,
          Supervisor: false,
        }));
      } else {
        setHandleValidate((prevState) => ({
          ...prevState,
          Supervisor: true,
        }));
      }
    }
  }, [optionsSupervisor]);

  const handleSearchButtonClick = (nameTable: string) => {
    onClickObtainMetrics(nameTable, undefined, undefined, undefined);
  };

  const handleXButtonClick = (nameTable: string) => {
    setPaginationState((prevState) => {
      return {
        ...prevState,
        [nameTable]: {
          ...prevState[nameTable],
          promotorName: "",
          supervisorName: "",
        },
      };
    });

    onClickObtainMetrics(nameTable, undefined, true, undefined);
  };

  const onChangeStartDate = (date: moment.Moment) => {
    cleanTableData();
    if (endDate && date && date.isAfter(endDate)) {
      setStartDate(date);
      setDisabledEndDate(false);
      setEndDate(undefined);
      setHandleValidate((prevState) => ({
        ...prevState,
        StartDate: true,
        EndDate: false,
      }));
      setForm({
        ...form,
        startDate: FormatDate(date, "YYYY-MM-DD"),
        endDate: "",
      });
    } else {
      setStartDate(date);
      setDisabledEndDate(false);
      setHandleValidate((prevState) => ({
        ...prevState,
        StartDate: true,
      }));
      setForm({
        ...form,
        startDate: FormatDate(date, "YYYY-MM-DD"),
      });
    }
  };

  const onChangeEndDate = (date: moment.Moment) => {
    cleanTableData();
    setEndDate(date);
    setHandleValidate((prevState) => ({
      ...prevState,
      EndDate: true,
    }));
    setForm({
      ...form,
      endDate: FormatDate(date, "YYYY-MM-DD"),
    });
  };

  const onChangeCoordinator = (selectedOption: SelectOption) => {
    cleanTableData();
    setValueSupervisor([]);
    setValueCoordinator([Number(selectedOption.value)]);
    setDisabledAdvisor(false);
    setDisabledPointOfSale(false);
    setDisabledSupervisor(false);
    setHandleValidate((prevState) => ({
      ...prevState,
      Coordinator: true,
    }));
    setForm({
      ...form,
      coordinatorId: Number(selectedOption.value),
      supervisorId: 0,
    });
    getSupervisorByCoordinator(Number(selectedOption.value));
  };

  const onChangeSupervisor = (selectedOption: SelectOption) => {
    cleanTableData();
    setValueSupervisor([Number(selectedOption.value)]);
    setDisabledAdvisor(false);
    setDisabledPointOfSale(false);
    setHandleValidate((prevState) => ({
      ...prevState,
      Coordinator: true,
      Supervisor: true,
    }));
    setForm({
      ...form,
      supervisorId: Number(selectedOption.value),
    });
  };

  const onChangeAdvisor = (on?: boolean, event?: React.SyntheticEvent) => {
    cleanTableData();
    if (on) {
      setSelectedTabIdDefault(1);
      setValueAdvisor(true);
      setValuePointOfSale(false);
      setHandleValidate((prevState) => ({
        ...prevState,
        Advisor: true,
        PointOfSale: true,
      }));
    } else {
      setValueAdvisor(false);
      setHandleValidate((prevState) => ({
        ...prevState,
        PointOfSale: false,
      }));
    }
  };

  const onChangePointOfSale = (on?: boolean, event?: React.SyntheticEvent) => {
    cleanTableData();
    if (on) {
      setSelectedTabIdDefault(1);
      setValuePointOfSale(true);
      setValueAdvisor(false);
      setHandleValidate((prevState) => ({
        ...prevState,
        Advisor: true,
        PointOfSale: true,
      }));
    } else {
      setValuePointOfSale(false);
      setHandleValidate((prevState) => ({
        ...prevState,
        PointOfSale: false,
      }));
    }
  };

  const handleSearchChange = (key: string, value: string, tableKey: string) => {
    if (key === "Supervisor") {
      setForm({
        ...form,
        supervisorName: value,
      });
      setPaginationState((prevState) => ({
        ...prevState,
        [tableKey]: {
          ...prevState[tableKey],
          supervisorName: value,
        },
      }));
    } else {
      setForm({
        ...form,
        promotorName: value,
      });
      setPaginationState((prevState) => ({
        ...prevState,
        [tableKey]: {
          ...prevState[tableKey],
          promotorName: value,
        },
      }));
    }
  };

  const onClearCoordinator = () => {
    setValueCoordinator([]);
    setValueSupervisor([]);
    setValueAdvisor(false);
    setValuePointOfSale(false);
    setDisabledSupervisor(true);
    setDisabledAdvisor(true);
    setDisabledPointOfSale(true);
    setHandleValidate((prevState) => ({
      ...prevState,
      Coordinator: false,
      Supervisor: false,
      Advisor: false,
      PointOfSale: false,
    }));
    cleanTableData();
    setForm({
      ...form,
      coordinatorId: 0,
    });
  };

  const onClearSupervisor = () => {
    setValueSupervisor([]);
    cleanTableData();
    setForm({
      ...form,
      supervisorId: 0,
    });
  };

  const israngeBeforeAndAfterDates = (day: MomentObj) => {
    return rangeBeforeAndAfterDates(day, startDate);
  };
  //Configuracion de la tabla
  const metrics1: TableColumns[] = [
    { id: "date", label: t("header.date") },
    {
      id: "supervisor",
      label: t("header.supervisor"),
      filter: (
        <TextBox
          id="textboxMetrics1"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Supervisor", value, "tableDataMetrics1")
          }
          value={paginationState.tableDataMetrics1.supervisorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataMetrics1")}
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() => handleXButtonClick("tableDataMetrics1")}
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    { id: "total_esf", label: t("header.totalEsf") },
    { id: "synchronization", label: t("header.synchronization") },
    { id: "check_in_late", label: t("header.checkInLate") },
    { id: "training_material", label: t("header.trainingMaterial") },
    { id: "absenceScheduling", label: t("header.absencesScheduling") },
    { id: "absences", label: t("header.absences") },
  ];

  const sync: TableColumns[] = [
    { id: "date", label: t("header.date") },
    {
      id: "supervisor",
      label: t("header.supervisor"),
      filter: (
        <TextBox
          id="textboxSync"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Supervisor", value, "tableDataSync")
          }
          value={paginationState.tableDataSync.supervisorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataSync")}
              >
                <IconSearch />
              </IconButton>

              <IconButton onClick={() => handleXButtonClick("tableDataSync")}>
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    {
      id: "promoter",
      label: t("header.promoter"),
      filter: (
        <TextBox
          id="textboxSyncPromoter"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Promoter", value, "tableDataSync")
          }
          value={paginationState.tableDataSync.promotorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataSync")}
              >
                <IconSearch />
              </IconButton>

              <IconButton onClick={() => handleXButtonClick("tableDataSync")}>
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    { id: "synchronized_days", label: t("header.synchronizedDays") },
    { id: "worked_days", label: t("header.workedDays") },
    { id: "percentage", label: t("header.percentage") },
    { id: "status", label: t("header.status") },
  ];

  const checkIn: TableColumns[] = [
    { id: "date", label: t("header.date") },
    { id: "photo", label: t("header.photo") },
    {
      id: "supervisor",
      label: t("header.supervisor"),
      filter: (
        <TextBox
          id="textboxCheckIn"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Supervisor", value, "tableDataCheckIn")
          }
          value={paginationState.tableDataCheckIn.supervisorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataCheckIn")}
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() => handleXButtonClick("tableDataCheckIn")}
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    {
      id: "promoter",
      label: t("header.promoter"),
      filter: (
        <TextBox
          id="textboxCheckInPromoter"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Promoter", value, "tableDataCheckIn")
          }
          value={paginationState.tableDataCheckIn.promotorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataCheckIn")}
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() => handleXButtonClick("tableDataCheckIn")}
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    { id: "posCode", label: t("header.posOfCode") },
    { id: "pointOfSale", label: t("header.pointOfSale") },
    { id: "scheduled_check_in", label: t("header.scheduledCheckIn") },
    { id: "registration_date", label: t("header.registrationDate") },
    { id: "difference_in_minutes", label: t("header.differenceInMinutes") },
    { id: "status", label: t("header.status") },
  ];

  const training: TableColumns[] = [
    { id: "date", label: t("header.date") },
    {
      id: "supervisor",
      label: t("header.supervisor"),
      filter: (
        <TextBox
          id="textboxTraining"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Supervisor", value, "tableDataTraining")
          }
          value={paginationState.tableDataTraining.supervisorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataTraining")}
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() => handleXButtonClick("tableDataTraining")}
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    {
      id: "promoter",
      label: t("header.promoter"),
      filter: (
        <TextBox
          id="textboxTrainingPromoter"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Promoter", value, "tableDataTraining")
          }
          value={paginationState.tableDataTraining.promotorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataTraining")}
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() => handleXButtonClick("tableDataTraining")}
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    { id: "quantity_Training", label: t("header.quantityTraining") },
    { id: "worked_days", label: t("header.workedDays") },
    { id: "absences", label: t("header.absences") },
    { id: "percentage", label: t("header.percentage") },
    { id: "status", label: t("header.status") },
  ];

  const absencesScheduling: TableColumns[] = [
    { id: "date", label: t("header.date") },
    {
      id: "supervisor",
      label: t("header.supervisor"),
      filter: (
        <TextBox
          id="textboxSheduling"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Supervisor", value, "tableDataAbsences")
          }
          value={paginationState.tableDataAbsences.supervisorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataAbsences")}
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() => handleXButtonClick("tableDataAbsences")}
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    {
      id: "promoter",
      label: t("header.promoter"),
      filter: (
        <TextBox
          id="textboxShedulingPromoter"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Promoter", value, "tableDataAbsences")
          }
          value={paginationState.tableDataAbsences.promotorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataAbsences")}
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() => handleXButtonClick("tableDataAbsences")}
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    { id: "absences", label: t("header.absences") },
    { id: "worked_days", label: t("header.workedDays") },
    { id: "status", label: t("header.status") },
    { id: "description", label: t("header.description") },
  ];

  const metrics2: TableColumns[] = [
    { id: "date", label: t("header.date") },
    {
      id: "supervisor",
      label: t("header.supervisor"),
      filter: (
        <TextBox
          id="textboxMetrics2"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Supervisor", value, "tableDataMetrics2")
          }
          value={paginationState.tableDataMetrics2.supervisorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataMetrics2")}
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() => handleXButtonClick("tableDataMetrics2")}
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    { id: "total_pos", label: t("header.totalPos") },
    { id: "share_of_shelf_print", label: t("header.sosPrint") },
    { id: "share_of_shelf_pc", label: t("header.sosPc") },
    { id: "competitor_advisors", label: t("header.competitionAdvisors") },
    { id: "visual_execution_print", label: t("header.visualExecutionPrint") },
    { id: "visual_execution_pc", label: t("header.visualExecutionPc") },
  ];

  const sosPrint: TableColumns[] = [
    { id: "date", label: t("header.date") },
    {
      id: "supervisor",
      label: t("header.supervisor"),
      filter: (
        <TextBox
          id="textboxSosPrint"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Supervisor", value, "tableDataSosPrint")
          }
          value={paginationState.tableDataSosPrint.supervisorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataSosPrint")}
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() => handleXButtonClick("tableDataSosPrint")}
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    { id: "pos_code", label: t("header.posOfCode") },
    { id: "point_of_sale", label: t("header.pos") },
    { id: "sub_total", label: "Sub-Total" },
    { id: "total", label: t("header.total") },
    { id: "metric", label: t("header.metrics") },
  ];

  const sosPc: TableColumns[] = [
    { id: "date", label: t("header.date") },
    {
      id: "supervisor",
      label: t("header.supervisor"),
      filter: (
        <TextBox
          id="textboxSosPc"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Supervisor", value, "tableDataSosPc")
          }
          value={paginationState.tableDataSosPc.supervisorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataSosPc")}
              >
                <IconSearch />
              </IconButton>

              <IconButton onClick={() => handleXButtonClick("tableDataSosPc")}>
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    { id: "pos_code", label: t("header.posOfCode") },
    { id: "point_of_sale", label: t("header.pos") },
    { id: "sub_total", label: "Sub-Total" },
    { id: "total", label: t("header.total") },
    { id: "metric", label: t("header.metrics") },
  ];

  const compAdvisors: TableColumns[] = [
    { id: "date", label: t("header.date") },
    {
      id: "supervisor",
      label: t("header.supervisor"),
      filter: (
        <TextBox
          id="textboxCompAdvisors"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Supervisor", value, "tableDataCompAdvisors")
          }
          value={paginationState.tableDataCompAdvisors.supervisorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataCompAdvisors")}
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() => handleXButtonClick("tableDataCompAdvisors")}
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    { id: "pos_code", label: t("header.posOfCode") },
    { id: "point_of_sale", label: t("header.pos") },
    { id: "sub_total", label: "Sub-Total" },
    { id: "total", label: t("header.total") },
    { id: "metric", label: t("header.metrics") },
  ];

  // const execVisualPrint: TableColumns[] = [
  //   { id: "date", label: t("header.date") },
  //   {
  //     id: "supervisor",
  //     label: t("header.supervisor"),
  //     filter: (
  //       <TextBox
  //         id="textboxExecVisualPrint"
  //         label={t("header.search")}
  //         type="search"
  //         onChange={(value) =>
  //           handleSearchChange("Supervisor", value, "tableDataExecVisualPrint")
  //         }
  //         value={paginationState.tableDataExecVisualPrint.supervisorName}
  //         trailingIcon={
  //           <>
  //             <IconButton
  //               onClick={() =>
  //                 handleSearchButtonClick("tableDataExecVisualPrint")
  //               }
  //             >
  //               <IconSearch />
  //             </IconButton>

  //             <IconButton
  //               onClick={() => handleXButtonClick("tableDataExecVisualPrint")}
  //             >
  //               <IconX />
  //             </IconButton>
  //           </>
  //         }
  //       />
  //     ),
  //   },
  //   { id: "pos_code", label: t("header.posOfCode") },
  //   { id: "point_of_sale", label: t("header.pos") },
  //   { id: "category", label: t("header.category") },
  //   { id: "brand", label: t("header.brand") },
  //   { id: "material_type", label: t("header.typeOfMaterial") },
  //   { id: "quantity", label: t("header.quantity") },
  // ];

  // const execVisualPc: TableColumns[] = [
  //   { id: "date", label: t("header.date") },
  //   {
  //     id: "supervisor",
  //     label: t("header.supervisor"),
  //     filter: (
  //       <TextBox
  //         id="textboxExecVisualPc"
  //         label={t("header.search")}
  //         type="search"
  //         onChange={(value) =>
  //           handleSearchChange("Supervisor", value, "tableDataExecVisualPc")
  //         }
  //         value={paginationState.tableDataExecVisualPc.supervisorName}
  //         trailingIcon={
  //           <>
  //             <IconButton
  //               onClick={() => handleSearchButtonClick("tableDataExecVisualPc")}
  //             >
  //               <IconSearch />
  //             </IconButton>

  //             <IconButton
  //               onClick={() => handleXButtonClick("tableDataExecVisualPc")}
  //             >
  //               <IconX />
  //             </IconButton>
  //           </>
  //         }
  //       />
  //     ),
  //   },
  //   { id: "pos_code", label: t("header.posOfCode") },
  //   { id: "point_of_sale", label: t("header.pos") },
  //   { id: "category", label: t("header.category") },
  //   { id: "brand", label: t("header.brand") },
  //   { id: "material_type", label: t("header.typeOfMaterial") },
  //   { id: "quantity", label: t("header.quantity") },
  // ];

  const execVisualPrintStatus: TableColumns[] = [
    { id: "date", label: t("header.date") },
    {
      id: "supervisor",
      label: t("header.supervisor"),
      filter: (
        <TextBox
          id="textboxExecVisualPrintStatus"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange(
              "Supervisor",
              value,
              "tableDataExecVisualPrintStatus"
            )
          }
          value={paginationState.tableDataExecVisualPrintStatus.supervisorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() =>
                  handleSearchButtonClick("tableDataExecVisualPrintStatus")
                }
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() =>
                  handleXButtonClick("tableDataExecVisualPrintStatus")
                }
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    { id: "pos_code", label: t("header.posOfCode") },
    { id: "point_of_sale", label: t("header.pos") },
    { id: "hp_quantity", label: t("header.hpQuantity") },
    { id: "competitor_quantity", label: t("header.quantityOfCompetition") },
    { id: "status", label: t("header.status") },
  ];

  const execVisualPcStatus: TableColumns[] = [
    { id: "date", label: t("header.date") },
    {
      id: "supervisor",
      label: t("header.supervisor"),
      filter: (
        <TextBox
          id="textboxExecVisualPcStatus"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange(
              "Supervisor",
              value,
              "tableDataExecVisualPcStatus"
            )
          }
          value={paginationState.tableDataExecVisualPcStatus.supervisorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() =>
                  handleSearchButtonClick("tableDataExecVisualPcStatus")
                }
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() =>
                  handleXButtonClick("tableDataExecVisualPcStatus")
                }
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    { id: "pos_code", label: t("header.posOfCode") },
    { id: "point_of_sale", label: t("header.pos") },
    { id: "hp_quantity", label: t("header.hpQuantity") },
    { id: "competitor_quantity", label: t("header.quantityOfCompetition") },
    { id: "status", label: t("header.status") },
  ];

  const absences: TableColumns[] = [
    { id: "date", label: t("header.date") },
    {
      id: "supervisor",
      label: t("header.supervisor"),
      filter: (
        <TextBox
          id="textboxAbsences"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Supervisor", value, "tableDataAbsencesCheckIn")
          }
          value={paginationState.tableDataAbsencesCheckIn.supervisorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataAbsencesCheckIn")}
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() => handleXButtonClick("tableDataAbsencesCheckIn")}
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    {
      id: "promoter",
      label: t("header.promoter"),
      filter: (
        <TextBox
          id="textboxAbsencesPromoter"
          label={t("header.search")}
          type="search"
          onChange={(value) =>
            handleSearchChange("Promoter", value, "tableDataAbsencesCheckIn")
          }
          value={paginationState.tableDataAbsencesCheckIn.promotorName}
          trailingIcon={
            <>
              <IconButton
                onClick={() => handleSearchButtonClick("tableDataAbsencesCheckIn")}
              >
                <IconSearch />
              </IconButton>

              <IconButton
                onClick={() => handleXButtonClick("tableDataAbsencesCheckIn")}
              >
                <IconX />
              </IconButton>
            </>
          }
        />
      ),
    },
    { id: "dias_De_CheckIn", label: t("header.CheckInDays") },
    { id: "dias_Laborales", label: t("header.WorkingDays") },
    { id: "dias_De_Ausencias", label: t("header.AbsenceDays") },
    { id: "status", label: t("header.status") },
  ];

  // Función para manejar el cambio de página
  const handlePageChange = (tableId: string, page: number) => {
    onClickObtainMetrics(tableId, page, undefined, undefined);

    setPaginationState((prevState) => ({
      ...prevState,
      [tableId]: {
        ...prevState[tableId],
        currentPage: page,
      },
    }));
  };

  // Función para manejar el cambio de tamaño de página
  const handlePageSizeChange = (tableId: string, pageSize: number) => {
    setPaginationState((prevState) => ({
      ...prevState,
      [tableId]: {
        ...prevState[tableId],
        pageSize: pageSize,
      },
    }));
  };

  // Función para obtener la configuración de paginación para cada tabla
  const getPaginationProps = (tableId: string, tableData: TableData) => {
    const { currentPage, pageSize } = paginationState[tableId];

    if (tableData.length > 1) {
      return {
        currentPage: currentPage,
        pageSize: pageSize,
        onPageChange: (page: number) => handlePageChange(tableId, page),
        onPageSizeChange: (
          event: React.MouseEvent<HTMLElement>,
          option: { value: number }
        ) => handlePageSizeChange(tableId, option.value),
        totalItems: Number(tableData[0].totalRecords),
      };
    } else {
      return {
        currentPage: currentPage,
        pageSize: pageSize,
        onPageChange: (page: number) => handlePageChange(tableId, page),
        onPageSizeChange: (
          event: React.MouseEvent<HTMLElement>,
          option: { value: number }
        ) => handlePageSizeChange(tableId, option.value),
        totalItems: tableData.length,
      };
    }
  };

  // Función que devuelve los datos paginados según la página y el tamaño de la página
  const pagedData = (tableId: string, tableData: TableData) => {
    return tableData.slice(0, 10);
  };

  //Tabs
  const onChangeTab = (value: number, viewedTable: string) => {
    setSelectedTabIdDefault(value);

    if (viewedTable === "showTable2") {
      value === 1
        ? setSelectedTable("DownloadMetricByAdvisor")
        : value === 2
        ? setSelectedTable("DownloadMetricSyncBySubRegion")
        : value === 3
        ? setSelectedTable("DownloadMetricCheckInBySubRegion")
        : value === 4
        ? setSelectedTable("DownloadMetricTrainigMaterialBySubRegion")
        : value === 5
        ? setSelectedTable("DownloadMetricAbsenceSchedulingBySubRegion")
        :setSelectedTable("DownloadMetricAbsenceBySubRegion");
    } else if (viewedTable === "showTable3") {
      value === 1
        ? setSelectedTable("DownloadMetricByPos")
        : value === 2
        ? setSelectedTable("DownloadMetricSosPrintBySubRegion")
        : value === 3
        ? setSelectedTable("DownloadMetricSosPcBySubRegion")
        : value === 4
        ? setSelectedTable("DownloadMetricEsfCoverageBySubRegion")
        : value === 5
        ? setSelectedTable("DownloadMetricVisualPrintBySubRegion")
        : value === 6
        ? setSelectedTable("DownloadMetricVisualPcBySubRegion")
        : value === 7
        ? setSelectedTable("DownloadMetricVisualPrintStatusBySubregion")
        : setSelectedTable("DownloadMetricVisualPcStatusBySubRegion");
    } else {
      value === 1
        ? setSelectedTable("DownloadMetricByAdvisor")
        : setSelectedTable("DownloadMetricByPos");
    }
  };

  const getFileList = async (
    form: IFormMetricsIn,
    nameService: keyof typeof metricService,
    setTable: React.Dispatch<React.SetStateAction<any[]>>,
    fillData: (
      data: any[],
      setTable: React.Dispatch<React.SetStateAction<TableData[]>>,
      setLoading: React.Dispatch<React.SetStateAction<boolean>>,
      columnMapping?: ITableColumnMapping
    ) => void,
    message: string,
    columnMapping?: ITableColumnMapping
  ) => {
    try {
      setMessage(message);
      setLoading(true);
      let result: any[];
      if (columnMapping) {
        result = await metricService[nameService](form);
        fillData(result, setTable, setLoading, columnMapping);
      } else {
        result = await metricService[nameService](form);
        fillData(result, setTable, setLoading);
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
      setLoading(false);
    }
  };

  const getCoordinatorBySubRegion = () => {
    dataListService.getCoordinatorBySubRegion().then((result: any[]) => {
      const updatedOptions = result.map((item) => ({
        value: item.coordinatorId,
        label: item.fullName,
      }));

      setOptionsCoordinator(updatedOptions);
    });
  };

  const getSupervisorByCoordinator = (coordinatorId: number) => {
    dataListService
      .getSupervisorByCoordinator(coordinatorId)
      .then((result: any[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.supervisorID,
          label: item.fullName,
        }));

        if (updatedOptions[0].value === 0) {
          updatedOptions[0].label = t("header.noSupervisorsAssigned");
        }

        setOptionsSupervisor(updatedOptions);
      });
  };

  const downloadMetrics = (form: IFormMetricsIn, nameExcel: string) => {
    let outputString = nameExcel.endsWith("BySubRegion") ? nameExcel.substring(0, nameExcel.length - "BySubRegion".length) : nameExcel;
    setLoading(true);

    metricService.downloadMetric(form).then((r: Blob | any) => {
      try {
        if (r?.statusCode === 401) {
          setMessage("donwload_failed");
        } else if (r instanceof Blob) {
          try {
            const url = window.URL.createObjectURL(r);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", outputString.substring(8) + ".xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            setMessage(t("header.generatingExcel"));
          } catch (error) {
            console.error("Error al descargar el archivo:", error);
          }
        }
      } catch (error) {
        console.error("Error al descargar el archivo:", error);
        setMessage("donwload_failed");
      } finally {
        setLoading(false);
      }
    });
  };

  const onClickObtainMetrics = async (
    nameTable: string | undefined,
    newPageValue: number | undefined,
    cleanFields: boolean | undefined,
    download: boolean | undefined
  ) => {
    const {
      StartDate,
      EndDate,
      Coordinator,
      Supervisor,
      Advisor,
      PointOfSale,
    } = memoizedHandleValidate;
    setIsButtonValidDowload(false)
    let newForm = { ...form };

    if (newPageValue !== undefined && nameTable !== undefined) {
      newForm.page = newPageValue - 1;
    }

    try {
      if (StartDate && EndDate) {
        if (!Coordinator && !Supervisor) {
          if (nameTable === "tableDataMetrics1") {
            if (cleanFields) {
              newForm.promotorName = "";
              newForm.supervisorName = "";
            } else {
              newForm.promotorName = paginationState[nameTable].promotorName;
              newForm.supervisorName =
                paginationState[nameTable].supervisorName;
            }

            if (download) {
              newForm.sp = selectedTable;
              newForm.languageID = languageID?.value;
              newForm.promotorName = undefined;
              downloadMetrics(newForm, selectedTable);
            } else {
              await getFileList(
                newForm,
                "getMetricByAdvisor",
                setTableDataMetrics1,
                fillDataMetricByAdvisor,
                t("header.consultingInformation"),
                undefined
              );
            }
          } else if (nameTable === "tableDataMetrics2") {
            if (cleanFields) {
              newForm.promotorName = "";
              newForm.supervisorName = "";
            } else {
              newForm.promotorName = paginationState[nameTable].promotorName;
              newForm.supervisorName =
                paginationState[nameTable].supervisorName;
            }

            if (download) {
              newForm.sp = selectedTable;
              newForm.languageID = languageID?.value;
              newForm.promotorName = undefined;
              downloadMetrics(newForm, selectedTable);
            } else {
              await getFileList(
                newForm,
                "GetMetricByPos",
                setTableDataMetrics2,
                fillDataMetricByPos,
                t("header.consultingInformation"),
                undefined
              );
            }
          } else {
            setShowTable3(false);
            setShowTable2(false);
            setShowTable1(true);
            newForm.promotorName = "";
            newForm.supervisorName = "";

            if (download) {
              newForm.sp = selectedTable;
              newForm.languageID = languageID?.value;
              newForm.promotorName = undefined;
              downloadMetrics(newForm, selectedTable);
            } else {
              await getFileList(
                newForm,
                "getMetricByAdvisor",
                setTableDataMetrics1,
                fillDataMetricByAdvisor,
                t("header.generatingMetricsByAdvisor"),
                undefined
              );

              await getFileList(
                newForm,
                "GetMetricByPos",
                setTableDataMetrics2,
                fillDataMetricByPos,
                t("header.generatingMetricsByPos"),
                undefined
              );
            }
          }
        } else {
          if (Advisor && PointOfSale) {
            if (valueAdvisor) {
              setShowTable1(false);
              setShowTable3(false);
              setShowTable2(true);

              const columnMappingCheckIn: ITableColumnMapping = {
                date: "date",
                supervisor: "supervisor",
                promoter: "promotor",
                scheduled_check_in: "checkIn_Programado",
                registration_date: "fecha_De_Registro",
                difference_in_minutes: "diferencia_En_Minutos",
                posCode: "posCode",
                pointOfSale: "punto_De_Venta",
                status: "status",
                photo: "photo",
                totalRecords: "totalRegistros",
              };

              const columnMappingAbsencesScheduling: ITableColumnMapping = {
                date: "date",
                supervisor: "supervisor",
                promoter: "promotor",
                absences: "ausencias",
                worked_days: "dias_Laborales",
                status: "status",
                description: "descripcion",
                totalRecords: "totalRegistros",
              };

              const columnMappingAbsences: ITableColumnMapping = {
                date: "date",
                supervisor: "supervisor",
                promoter: "promotor",
                dias_De_CheckIn: "dias_De_CheckIn",
                dias_Laborales: "dias_Laborales",
                dias_De_Ausencias: "dias_De_Ausencias",
                status: "status",
                totalRecords: "totalRegistros",
              };

              if (nameTable === "tableDataMetrics1") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricByAdvisor",
                    setTableDataMetrics1,
                    fillDataMetricByAdvisor,
                    t("header.consultingInformation"),
                    undefined
                  );
                }
              } else if (nameTable === "tableDataSync") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }
                
                
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricSyncBySubRegionWeb",
                    setTableDataSync,
                    fillDataMetricSync,
                    t("header.consultingInformation"),
                    undefined
                  );
                }
              } else if (nameTable === "tableDataCheckIn") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "GetMetricCheckInBySubRegionWeb",
                    setTableDataCheckIn,
                    fillDataMetricCheckIn,
                    t("header.consultingInformation"),
                    columnMappingCheckIn
                  );
                }
              } else if (nameTable === "tableDataTraining") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricTrainigMaterialBySubRegionWeb",
                    setTableDataTraining,
                    fillDataMetricTraining,
                    t("header.consultingInformation"),
                    undefined
                  );
                }
              } else if (nameTable === "tableDataAbsences") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }

                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricAbsenceSchedulingBySubRegionWeb",
                    setTableDataAbsences,
                    fillDataGeneric,
                    t("header.consultingInformation"),
                    columnMappingAbsencesScheduling
                  );
                }
              } else if (nameTable === "tableDataAbsencesCheckIn") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }

                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricAbsenceCheckInBySubRegionWeb",
                    setTableDataAbsencesCheckIn,
                    fillDataGeneric,
                    t("header.consultingInformation"),
                    columnMappingAbsences
                  );
                }
              }
              else {
                newForm.promotorName = "";
                newForm.supervisorName = "";

                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricByAdvisor",
                    setTableDataMetrics1,
                    fillDataMetricByAdvisor,
                    t("header.generatingMetricsByAdvisor"),
                    undefined
                  );

                  await getFileList(
                    newForm,
                    "getMetricSyncBySubRegionWeb",
                    setTableDataSync,
                    fillDataMetricSync,
                    t("header.generatingSyncMetrics"),
                    undefined
                  );

                  await getFileList(
                    newForm,
                    "GetMetricCheckInBySubRegionWeb",
                    setTableDataCheckIn,
                    fillDataMetricCheckIn,
                    t("header.generatingCheckInMetrics"),
                    columnMappingCheckIn
                  );

                  await getFileList(
                    newForm,
                    "getMetricTrainigMaterialBySubRegionWeb",
                    setTableDataTraining,
                    fillDataMetricTraining,
                    t("header.generatingTrainingMaterialMetrics"),
                    undefined
                  );

                  await getFileList(
                    newForm,
                    "getMetricAbsenceSchedulingBySubRegionWeb",
                    setTableDataAbsences,
                    fillDataGeneric,
                    t("header.generatingAbsenceMetrics"),
                    columnMappingAbsencesScheduling
                  );

                  await getFileList(
                    newForm,
                    "getMetricAbsenceCheckInBySubRegionWeb",
                    setTableDataAbsencesCheckIn,
                    fillDataGeneric,
                    t("header.generatingAbsenceMetrics"),
                    columnMappingAbsences
                  );
                }
              }
            } else {
              setShowTable1(false);
              setShowTable2(false);
              setShowTable3(true);

              const columnMappingSos: ITableColumnMapping = {
                date: "date",
                supervisor: "supervisor",
                pos_code: "posCode",
                point_of_sale: "pos",
                sub_total: "subtotal",
                total: "total",
                metric: "metrica",
                totalRecords: "totalRegistros",
              };

              const columnMappingExecVisual: ITableColumnMapping = {
                date: "date",
                supervisor: "supervisor",
                pos_code: "posCode",
                point_of_sale: "pos",
                category: "categoria",
                brand: "marca",
                material_type: "tipo_De_Material",
                quantity: "cantidad",
                totalRecords: "totalRegistros",
              };

              const columnMappingExecVisualStatus: ITableColumnMapping = {
                date: "date",
                supervisor: "supervisor",
                pos_code: "posCode",
                point_of_sale: "pos",
                hp_quantity: "cantidad_de_HP",
                competitor_quantity: "cantidad_de_Competencia",
                status: "status",
                totalRecords: "totalRegistros",
              };

              if (nameTable === "tableDataMetrics2") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "GetMetricByPos",
                    setTableDataMetrics2,
                    fillDataMetricByPos,
                    t("header.consultingInformation"),
                    undefined
                  );
                }
              } else if (nameTable === "tableDataSosPrint") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricSosPrintBySubRegion",
                    setTableDataSosPrint,
                    fillDataGeneric,
                    t("header.consultingInformation"),
                    columnMappingSos
                  );
                }
              } else if (nameTable === "tableDataSosPc") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricSosPcBySubRegion",
                    setTableDataSosPc,
                    fillDataGeneric,
                    t("header.consultingInformation"),
                    columnMappingSos
                  );
                }
              } else if (nameTable === "tableDataCompAdvisors") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricEsfCoverageBySubRegionWeb",
                    setTableDataCompAdvisors,
                    fillDataGeneric,
                    t("header.consultingInformation"),
                    columnMappingSos
                  );
                }
              } else if (nameTable === "tableDataExecVisualPrint") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricVisualPrintBySubRegionWeb",
                    setTableDataExecVisualPrint,
                    fillDataGeneric,
                    t("header.consultingInformation"),
                    columnMappingExecVisual
                  );
                }
              } else if (nameTable === "tableDataExecVisualPc") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricVisualPcBySubRegionWeb",
                    setTableDataExecVisualPc,
                    fillDataGeneric,
                    t("header.consultingInformation"),
                    columnMappingExecVisual
                  );
                }
              } else if (nameTable === "tableDataExecVisualPrintStatus") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricVisualPrintStatusBySubregionWeb",
                    setTableDataExecVisualPrintStatus,
                    fillDataGeneric,
                    t("header.consultingInformation"),
                    columnMappingExecVisualStatus
                  );
                }
              } else if (nameTable === "tableDataExecVisualPcStatus") {
                if (cleanFields) {
                  newForm.promotorName = "";
                  newForm.supervisorName = "";
                } else {
                  newForm.promotorName =
                    paginationState[nameTable].promotorName;
                  newForm.supervisorName =
                    paginationState[nameTable].supervisorName;
                }
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "getMetricVisualPcStatusBySubRegionWeb",
                    setTableDataExecVisualPcStatus,
                    fillDataGeneric,
                    t("header.consultingInformation"),
                    columnMappingExecVisualStatus
                  );
                }
              } else {
                newForm.promotorName = "";
                newForm.supervisorName = "";
                if (download) {
                  newForm.sp = selectedTable;
                  newForm.languageID = languageID?.value;
                  newForm.promotorName = undefined;
                  downloadMetrics(newForm, selectedTable);
                } else {
                  await getFileList(
                    newForm,
                    "GetMetricByPos",
                    setTableDataMetrics2,
                    fillDataMetricByPos,
                    t("header.generatingMetricsByPos"),
                    undefined
                  );

                  await getFileList(
                    newForm,
                    "getMetricSosPrintBySubRegion",
                    setTableDataSosPrint,
                    fillDataGeneric,
                    t("header.generatingSosPrintingMetrics"),
                    columnMappingSos
                  );

                  await getFileList(
                    newForm,
                    "getMetricSosPcBySubRegion",
                    setTableDataSosPc,
                    fillDataGeneric,
                    t("header.generatingSosPcMetrics"),
                    columnMappingSos
                  );

                  await getFileList(
                    newForm,
                    "getMetricEsfCoverageBySubRegionWeb",
                    setTableDataCompAdvisors,
                    fillDataGeneric,
                    t("header.generatingCompetitorAdvisorMetrics"),
                    columnMappingSos
                  );

                  await getFileList(
                    newForm,
                    "getMetricVisualPrintBySubRegionWeb",
                    setTableDataExecVisualPrint,
                    fillDataGeneric,
                    t("header.generatingVisualExecutionPrintingMetrics"),
                    columnMappingExecVisual
                  );

                  await getFileList(
                    newForm,
                    "getMetricVisualPcBySubRegionWeb",
                    setTableDataExecVisualPc,
                    fillDataGeneric,
                    t("header.generatingVisualExecutionPcMetrics"),
                    columnMappingExecVisual
                  );

                  await getFileList(
                    newForm,
                    "getMetricVisualPrintStatusBySubregionWeb",
                    setTableDataExecVisualPrintStatus,
                    fillDataGeneric,
                    t("header.generatingPrintingStatusMetrics"),
                    columnMappingExecVisualStatus
                  );

                  await getFileList(
                    newForm,
                    "getMetricVisualPcStatusBySubRegionWeb",
                    setTableDataExecVisualPcStatus,
                    fillDataGeneric,
                    t("header.generatingPcStatusMetrics"),
                    columnMappingExecVisualStatus
                  );
                }
              }
            }
          }
        }
      }
    } catch (error) {}
  };

  const isFutureDate = (day: MomentObj) => {
  return day.isAfter(moment(), "day");
};

  return (
    <>
      {loading && (
        <div>
          <LoaderModal>
            <div>{message}</div>
          </LoaderModal>
        </div>
      )}

      <div style={{ padding: "1%" }}>
        <h4>{t("header.metrics")}</h4>
      </div>

      <div className="container">
        <div className="row">
          <div className="column leftDatePicker">
            <DatePicker
              className="datePicker"
              monthYearNavigation
              onChange={(date) => onChangeStartDate(date as moment.Moment)}
              clearIcon={false}
              value={startDate}
              placeholder="dd/mm/yyyy"
              format="LL"
              calendarOrientation={["right", "down"]}
              orientation="horizontal"
              label={t("header.stardDate")}
              isOutsideRange={isFutureDate}
            />

            <DatePicker
              className="datePicker"
              monthYearNavigation
              onChange={(date) => onChangeEndDate(date as moment.Moment)}
              clearIcon={false}
              value={endDate}
              placeholder="dd/mm/yyyy"
              format="LL"
              calendarOrientation={["right", "down"]}
              orientation="horizontal"
              label={t("header.endDate")}
              disabled={disabledEndDate}
              isOutsideRange={israngeBeforeAndAfterDates}
              maxDate={startDate}
            />
          </div>

          <div className="column centerSelect">
            <Select
              className="select"
              options={optionsCoordinator}
              id="select-coordinator"
              label={t("header.coordinator")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeCoordinator}
              onClear={onClearCoordinator}
              value={valueCoordinator}
            />

            <Select
              className="select"
              options={optionsSupervisor}
              id="select-supervisor"
              label={t("header.supervisor")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeSupervisor}
              onClear={onClearSupervisor}
              value={valueSupervisor}
              disabled={disabledSupervisor}
            />
          </div>

          <div className="column rightToggle">
            <Toggle
              className="toggle"
              label={t("header.advisor")}
              id="toggle_Advisor"
              onChange={onChangeAdvisor}
              on={valueAdvisor}
              disabled={disabledAdvisor}
            />

            <Toggle
              className="toggle"
              label={t("header.pointOfSale")}
              id="toggle_PointOfSale"
              onChange={onChangePointOfSale}
              on={valuePointOfSale}
              disabled={disabledPointOfSale}
            />
          </div>
        </div>

        <div className="row">
          <div className="button-container">
            <Button
              onClick={() =>
                onClickObtainMetrics(undefined, undefined, undefined, undefined)
              }
              disabled={isButtonValid}
            >
              {t("header.obtainMetrics")}
            </Button>

            <Button
              appearance="secondary"
              onClick={clearFilters}
              disabled={false}
            >
              {t("header.clearFilters")}
            </Button>

            <div className="tooltip">
              <span className="tooltiptext">{t("header.downloadMetrics")}</span>
              <Button
                onClick={() =>
                  onClickObtainMetrics(undefined, undefined, undefined, true)
                }
                style={{ margin: "5px" }}
                appearance="secondary"
                leadingIcon={<IconDocument />}
                disabled={isButtonValidDowload}
              ></Button>
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding: "20px" }}>
        {showTable2 ? (
          <Tabs
            controlId="default"
            onChangeTab={(value) => onChangeTab(value, "showTable2")}
            selectedTabId={selectedTabIdDefault}
            tabs={[
              {
                id: 1,
                label: t("header.metricsByAdvisor"),
                content: (
                  <div>
                    <Table
                      showFilters={true}
                      columnResize
                      loading={loading}
                      columns={metrics1}
                      data={pagedData("tableDataMetrics1", tableDataMetrics1)}
                      loadingDataLength={10}
                      pagination={getPaginationProps(
                        "tableDataMetrics1",
                        tableDataMetrics1
                      )}
                      behavior={{
                        type: "singlePage",
                      }}
                    />
                  </div>
                ),
              },
              {
                id: 2,
                label: t("header.synchronization"),
                content: (
                  <div>
                    <Table
                      showFilters={true}
                      columnResize
                      loading={loading}
                      columns={sync}
                      data={pagedData("tableDataSync", tableDataSync)}
                      loadingDataLength={10}
                      pagination={getPaginationProps(
                        "tableDataSync",
                        tableDataSync
                      )}
                      behavior={{
                        type: "singlePage",
                      }}
                    />
                  </div>
                ),
              },
              {
                id: 3,
                label: t("header.checkInLate"),
                content: (
                  <div>
                    <Table
                      showFilters={true}
                      columnResize
                      loading={loading}
                      columns={checkIn}
                      data={pagedData("tableDataCheckIn", tableDataCheckIn)}
                      loadingDataLength={10}
                      pagination={getPaginationProps(
                        "tableDataCheckIn",
                        tableDataCheckIn
                      )}
                      behavior={{
                        type: "singlePage",
                      }}
                    />
                  </div>
                ),
              },
              {
                id: 4,
                label: t("header.trainingMaterial"),
                content: (
                  <div>
                    <Table
                      showFilters={true}
                      columnResize
                      loading={loading}
                      columns={training}
                      data={pagedData("tableDataTraining", tableDataTraining)}
                      loadingDataLength={10}
                      pagination={getPaginationProps(
                        "tableDataTraining",
                        tableDataTraining
                      )}
                      behavior={{
                        type: "singlePage",
                      }}
                    />
                  </div>
                ),
              },
              {
                id: 5,
                label: t("header.absencesScheduling"),
                content: (
                  <div>
                    <Table
                      showFilters={true}
                      columnResize
                      loading={loading}
                      columns={absencesScheduling}
                      data={pagedData("tableDataAbsences", tableDataAbsences)}
                      loadingDataLength={10}
                      pagination={getPaginationProps(
                        "tableDataAbsences",
                        tableDataAbsences
                      )}
                      behavior={{
                        type: "singlePage",
                      }}
                    />
                  </div>
                ),
              },
              {
                id: 6,
                label: t("header.absences"),
                content: (
                  <div>
                    <Table
                      showFilters={true}
                      columnResize
                      loading={loading}
                      columns={absences}
                      data={pagedData("tableDataAbsencesCheckIn", tableDataAbsencesCheckIn)}
                      loadingDataLength={10}
                      pagination={getPaginationProps(
                        "tableDataAbsencesCheckIn",
                        tableDataAbsencesCheckIn
                      )}
                      behavior={{
                        type: "singlePage",
                      }}
                    />
                  </div>
                ),
              },
            ]}
            type="attached"
          />
        ) : showTable3 ? (
          <div>
            <Tabs
              controlId="default"
              onChangeTab={(value) => onChangeTab(value, "showTable3")}
              selectedTabId={selectedTabIdDefault}
              tabs={[
                {
                  id: 1,
                  label: t("header.metricsByPointOfSale"),
                  content: (
                    <div>
                      <Table
                        showFilters={true}
                        columnResize
                        loading={loading}
                        columns={metrics2}
                        data={pagedData("tableDataMetrics2", tableDataMetrics2)}
                        loadingDataLength={10}
                        pagination={getPaginationProps(
                          "tableDataMetrics2",
                          tableDataMetrics2
                        )}
                        behavior={{
                          type: "singlePage",
                        }}
                      />
                    </div>
                  ),
                },
                {
                  id: 2,
                  label: t("header.sosPrint"),
                  content: (
                    <div>
                      <Table
                        showFilters={true}
                        columnResize
                        loading={loading}
                        columns={sosPrint}
                        data={pagedData("tableDataSosPrint", tableDataSosPrint)}
                        loadingDataLength={10}
                        pagination={getPaginationProps(
                          "tableDataSosPrint",
                          tableDataSosPrint
                        )}
                        behavior={{
                          type: "singlePage",
                        }}
                      />
                    </div>
                  ),
                },
                {
                  id: 3,
                  label: t("header.sosPc"),
                  content: (
                    <div>
                      <Table
                        showFilters={true}
                        columnResize
                        loading={loading}
                        columns={sosPc}
                        data={pagedData("tableDataSosPc", tableDataSosPc)}
                        loadingDataLength={10}
                        pagination={getPaginationProps(
                          "tableDataSosPc",
                          tableDataSosPc
                        )}
                        behavior={{
                          type: "singlePage",
                        }}
                      />
                    </div>
                  ),
                },
                {
                  id: 4,
                  label: t("header.competitionAdvisors"),
                  content: (
                    <div>
                      <Table
                        showFilters={true}
                        columnResize
                        loading={loading}
                        columns={compAdvisors}
                        data={pagedData(
                          "tableDataCompAdvisors",
                          tableDataCompAdvisors
                        )}
                        loadingDataLength={10}
                        pagination={getPaginationProps(
                          "tableDataCompAdvisors",
                          tableDataCompAdvisors
                        )}
                        behavior={{
                          type: "singlePage",
                        }}
                      />
                    </div>
                  ),
                },
                // {
                //   id: 5,
                //   label: t("header.visualExecutionPrint"),
                //   content: (
                //     <div>
                //       <Table
                //         showFilters={true}
                //         columnResize
                //         loading={loading}
                //         columns={execVisualPrint}
                //         data={pagedData(
                //           "tableDataExecVisualPrint",
                //           tableDataExecVisualPrint
                //         )}
                //         loadingDataLength={10}
                //         pagination={getPaginationProps(
                //           "tableDataExecVisualPrint",
                //           tableDataExecVisualPrint
                //         )}
                //         behavior={{
                //           type: "singlePage",
                //         }}
                //       />
                //     </div>
                //   ),
                // },
                // {
                //   id: 6,
                //   label: t("header.visualExecutionPc"),
                //   content: (
                //     <div>
                //       <Table
                //         showFilters={true}
                //         columnResize
                //         loading={loading}
                //         columns={execVisualPc}
                //         data={pagedData(
                //           "tableDataExecVisualPc",
                //           tableDataExecVisualPc
                //         )}
                //         loadingDataLength={10}
                //         pagination={getPaginationProps(
                //           "tableDataExecVisualPc",
                //           tableDataExecVisualPc
                //         )}
                //         behavior={{
                //           type: "singlePage",
                //         }}
                //       />
                //     </div>
                //   ),
                // },
                {
                  id: 7,
                  label: t("header.execVisualPrintStatus"),
                  content: (
                    <div>
                      <Table
                        showFilters={true}
                        columnResize
                        loading={loading}
                        columns={execVisualPrintStatus}
                        data={pagedData(
                          "tableDataExecVisualPrintStatus",
                          tableDataExecVisualPrintStatus
                        )}
                        loadingDataLength={10}
                        pagination={getPaginationProps(
                          "tableDataExecVisualPrintStatus",
                          tableDataExecVisualPrintStatus
                        )}
                        behavior={{
                          type: "singlePage",
                        }}
                      />
                    </div>
                  ),
                },
                {
                  id: 8,
                  label: t("header.execVisualPcStatus"),
                  content: (
                    <div>
                      <Table
                        showFilters={true}
                        columnResize
                        loading={loading}
                        columns={execVisualPcStatus}
                        data={pagedData(
                          "tableDataExecVisualPcStatus",
                          tableDataExecVisualPcStatus
                        )}
                        loadingDataLength={10}
                        pagination={getPaginationProps(
                          "tableDataExecVisualPcStatus",
                          tableDataExecVisualPcStatus
                        )}
                        behavior={{
                          type: "singlePage",
                        }}
                      />
                    </div>
                  ),
                },
              ]}
              type="attached"
            />
          </div>
        ) : showTable1 ? (
          <Tabs
            className="tabsTable"
            controlId="default"
            onChangeTab={(value) => onChangeTab(value, "showTable1")}
            selectedTabId={selectedTabIdDefault}
            tabs={[
              {
                id: 1,
                label: t("header.metricsByAdvisor"),
                content: (
                  <div>
                    <Table
                      showFilters={true}
                      columnResize={true}
                      loading={loading}
                      columns={metrics1}
                      data={pagedData("tableDataMetrics1", tableDataMetrics1)}
                      loadingDataLength={10}
                      pagination={getPaginationProps(
                        "tableDataMetrics1",
                        tableDataMetrics1
                      )}
                      behavior={{
                        type: "singlePage",
                      }}
                    />
                  </div>
                ),
              },
              {
                id: 2,
                label: t("header.metricsByPointOfSale"),
                content: (
                  <div>
                    <Table
                      showFilters={true}
                      columnResize={true}
                      loading={loading}
                      columns={metrics2}
                      data={pagedData("tableDataMetrics2", tableDataMetrics2)}
                      loadingDataLength={10}
                      pagination={getPaginationProps(
                        "tableDataMetrics2",
                        tableDataMetrics2
                      )}
                      behavior={{
                        type: "singlePage",
                      }}
                    />
                  </div>
                ),
              },
            ]}
            type="attached"
          />
        ) : null}
      </div>
    </>
  );
}
